(function(window, document, $, undefined) {

    'use strict'

    if (typeof $ === undefined) {
        throw new Error('jQuery seems to be missing...');
    }

    $(function() {

        // Prevents unexpected menu close when clicking in the dropdown
        // ------------------------------------
        $(document).on('click', '.yamm .dropdown-menu', function(e) {
            e.stopPropagation();
        });

        // Show site-overlay on dropdown collapse
        // ------------------------------------
        var $body = $('body');

        $('.nav-primary .dropdown').on('show.bs.dropdown', function() {
            $body.toggleClass('nav-open', true);
            if (!Modernizr.touchevents) {
                var $inner = $(this).find('.dropdown-menu-inner');
                $inner.find('[class^="col-"]').css({ height: $inner.outerHeight() });
            }
        }).on('hide.bs.dropdown', function() {
            if (!Modernizr.touchevents) {
                $body.toggleClass('nav-open', false);
            }
        });

        $('.site-overlay').click(function() {
            $body.removeClass('nav-open');
            $('.navbar-collapse').collapse('hide');
        });

        $('.navbar-collapse')
            .on('show.bs.collapse', function() {
                $body.toggleClass('nav-open', true);
            })
            .on('hide.bs.collapse', function() {
                $body.toggleClass('nav-open', false);
            });

        $('.nav-secondary .dropdown-fw.dropdown-instance-navigation').css({
            width: '282px',
            left: '-80px'
        });

        // Expands the dropdown-menu across the full width of the page
        // ------------------------------------
        var innerMenuWidthFix = function(windowWidth) {
            $('.dropdown-menu:has(.dropdown-menu-inner)').each(function() {
                var $el = $(this),
                    elementWidth = $el.data('w'),
                    offset;

                // On first call, save a reference to the original width
                if (!elementWidth) {
                    elementWidth = $el.width();
                    $el.data('w', elementWidth);
                } else {
                    elementWidth = $el.data('w');
                }

                // calculate and apply the required offset
                offset = (windowWidth - elementWidth) / 2;
                $el.css({ left: -offset, right: -offset });
            });
        };

        $(window).on('resize', $.debounce(250, function() {
            innerMenuWidthFix($(this).width());
        }));

        innerMenuWidthFix($(window).width());

        // Triple P Selector
        // ------------------------------------

        // @note this should be put in a self containing function

        var $tpsContainer = $('.triple-p-selector'),
            tpsSliderInstance;

        // Triple P Slider logic
        function initTpsSlider(scope) {
            var $tpsSliderEl = $('.triple-p-selector-slider');

            if ($tpsSliderEl.length > 0) {
                tpsSliderInstance = $tpsSliderEl.bxSlider({
                    pager: false,
                    controls: false,
                    infiniteLoop: false
                });
            }
        }
    });
})(window, document, window.jQuery);